module.exports = __webpack_public_path__ + "static/media/menu_site.2fd1f8a6.svg";